import { render, staticRenderFns } from "./LayerDisplay.vue?vue&type=template&id=f38c0e8e&scoped=true"
import script from "./LayerDisplay.vue?vue&type=script&lang=js"
export * from "./LayerDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38c0e8e",
  null
  
)

export default component.exports